import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, HostBinding, HostListener, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { SettingsSetterDirective } from 'src/business/models/general-element-settings';
import { Guard } from 'src/core-lib/misselaineous/guards';



@Component({
    selector: 'editor-rich-text-element',
    templateUrl: './rich-text.component.html',
    styleUrls: [
        './rich-text.component.scss',
        './components.scss',
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class EditorRichTextComponent extends SettingsSetterDirective implements OnInit {

    @HostBinding('innerHTML') _text: SafeHtml;
    @HostBinding('class.rte') _class = true;
    @HostBinding('style.textAlign') align: string;
    set text(text: string) {
        this._text = this.sanitize.bypassSecurityTrustHtml(text);
    }
    @HostListener('click', ['$event']) onClick(event: any): boolean {
        if (event.target.tagName === 'A') {
            const url = event.target.getAttribute('href');
            const target = event.target.getAttribute('target');
            const download = event.target.getAttribute('download');
            if (Guard.is.nullOrUndefined(download) && target !== '_blank' && url.startsWith('/')) {
                event.preventDefault();
                this.router.navigateByUrl(url);
                return;
            }
        }
        return true;
    }

    constructor(
        private router: Router,
        private sanitize: DomSanitizer,
        elm:ElementRef, _detector: ChangeDetectorRef
    ) {
        super(elm, _detector);


    }

    ngOnInit() {
        super.ngOnInit();
        this.align = this.settings?.position;
    }
}
